import numeral from "numeral"
import helpers from "helpers"

export default {
	subdivisionsColumns: [
		{
			id: "checkbox",
			header: "",
			filterable: false,
			width: 15,
		},
		{
			id: "id",
			header: "ID",
		},
		{
			id: "name",
			header: "Neighborhood",
			cell: ({ row, getValue }) => row.original?.nameLink || getValue(),
			sortingFn: (rowA, rowB) => {
				const normalize = (row) => {
					const raw = row.original?.name || row.original?.public_name || ""
					return typeof raw === "string" ? raw.toLowerCase() : ""
				}
				return normalize(rowA).localeCompare(normalize(rowB))
			},
		},
		{
			id: "communityName",
			header: "Community",
		},
		{
			id: "developerName",
			header: "Developer",
		},
		{
			id: "status",
			header: "Status",
		},
		{
			id: "prices",
			header: "Price Range",
			cell: (v) => {
				let val = v.getValue()
				if (!val?.min && !val?.max) return ""
				return `${numeral(v.getValue().min).format("$0ak")} - ${numeral(v.getValue().max).format("$0ak")}`
			},
		},
		{
			id: "lot_types",
			header: "Lot Sizes",
			cell: (v) => {
				let val = v.getValue()
				if (Array.isArray(val)) {
					let ret = []
					val.forEach((v) => {
						if (v && v < 500) ret.push(v)
						else if (v && v >= 500) ret.push(helpers.translateLargeLotTypes(v))
					})
					// Sort lot types numerically (lowest to highest)
					ret.sort((a, b) => {
						const aNum = parseInt(a)
						const bNum = parseInt(b)
						if (!isNaN(aNum) && !isNaN(bNum)) return aNum - bNum
						return a.toString().localeCompare(b.toString())
					})
					return ret.join(", ")
				} else return ""
			},
		},
		{
			id: "builders_names",
			header: "Builders",
			cell: (v) => {
				let val = v.getValue()
				if (Array.isArray(val)) {
					// Sort builders alphabetically
					const sorted = [...val].sort((a, b) => a.localeCompare(b))
					return sorted.join(", ")
				} else if (typeof val === 'string') {
					try {
						// Handle case where it might be a JSON string
						const parsed = JSON.parse(val)
						if (Array.isArray(parsed)) {
							const sorted = [...parsed].sort((a, b) => a.localeCompare(b))
							return sorted.join(", ")
						}
					} catch (e) {
						// If not JSON, treat as regular string
						return val
					}
				}
				return val || ""
			},
		},
		{
			id: "starts",
			header: "Quarterly Starts",
		},
		{
			id: "futures",
			header: "Futures",
		},
		{
			id: "vdls",
			header: "VDL",
		},
		{
			id: "closings",
			header: "Quarterly Closings",
		},
		{
			id: "complete_vacant",
			header: "Finished Vacant",
		},
	],
	subdivisionColumns: [
		{
			id: "map_id",
			header: "ID",
			sortingFn: (rowA, rowB) => {
				return Number(rowA.original?.map_id || 0) - Number(rowB.original?.map_id || 0)
			},
		},
		{
			id: "section",
			header: "Section",
		},
		{
			id: "subdivisionName",
			header: "Neighborhood",
		},
		{
			id: "price_range_text",
			header: "Price Range",
		},
		{
			id: "sqft_range_text",
			header: "SF Range",
		},
		{
			id: "quarter_start",
			header: "Active Quarter",
		},
		{
			id: "quarter_complete",
			header: "Builtout Quarter",
		},
		{
			id: "starts",
			header: "Quarterly Starts",
		},
		{
			id: "closings",
			header: "Quarterly Closings",
		},
		{
			id: "under_construction",
			header: "Under Construction",
		},
		{
			id: "complete_vacant",
			header: "Finished Vacant",
		},
		{
			id: "models",
			header: "Models",
		},
		{
			id: "occupied",
			header: "Occupied",
		},
		{
			id: "vdls",
			header: "VDL",
		},
		{
			id: "futures",
			header: "Futures",
		},
		{
			id: "total",
			header: "Total",
		},
	],
}
